import styles from "./loyalty.module.scss";
import cn from "classnames";
import { LABEL } from "../../veriables";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const LoyaltyBalanceOffers = ({ loyaltyOffers, handleRouteToChecKListing, serverAppTheme, isLandScape, seat, orderingPortraitOrientation }) => {

  const loyaltyData = loyaltyOffers || null;


  const shouldShowOfferValue = (item) =>
    item?.showAsQuantity ? Number(item?.quantity) > 0 : Number(item?.value) > 0;

  const getOfferValueText = (item) =>
    item?.showAsQuantity
      ? `${LABEL().LS_QUANTITY}: ${Math.trunc(Number(item?.quantity) || 0)}`
      : `${LABEL().LS_VALUE}: ${LABEL().CURRENCY_SYMBOL}${(Number(item?.value) || 0).toFixed(2)}`;

  return (
    <div
    // className={cn("col-12 d-flex flex-column h-92 justify-content-center px-0")}
      className={cn(
        "col-12 d-flex flex-column justify-content-center px-0",
        (window.location.pathname.includes("/loyalty-balance") ? (orderingPortraitOrientation ? 'h-96' : "h-92") : "h-92")
      )}

    >
      {(loyaltyData?.guestName || loyaltyData?.displayAccountNumber) && (
        <>
          <div className="pt-3"></div>
          <div
            className={cn(
              "d-flex justify-content-between align-items-center mb-3 p-2 fs_12 fw-400 rounded",  orderingPortraitOrientation ? 'mx-0' : 'mx-3'
            )}
            style={{
              background: serverAppTheme?.checkDetail_tabs,
              color: serverAppTheme?.primary_text,
              minHeight: '40px'
            }}
          >
            <div className="text-left">
              {loyaltyData?.guestName && (
                <span className="fs_16 fw-600" style={{ color: serverAppTheme?.primary_text }}>
                  {loyaltyData.guestName}
                </span>
              )}
            </div>
            <div className="text-right">
              {loyaltyData?.displayAccountNumber && (
                <span className="fs_16 fw-600" style={{ color: serverAppTheme?.primary_text }}>
                  {loyaltyData.displayAccountNumber}
                </span>
              )}
            </div>
          </div>
        </>
      )}
      <div className={cn("mb-2 overflowY", isLandScape ? 'h-80 px-3' : 'h-90')}>
        {loyaltyOffers?.offers?.length > 0 ? (
          loyaltyOffers?.offers?.map((item, i) => {
            return (
                <div
                  className={cn(
                    styles.offersBox,
                    "row mx-0 mb-2 p-2 col-12",
                  )}
                  role="presentation"
                  style={{
                    background: serverAppTheme?.tip_tile,
                    border: `1px solid ${serverAppTheme?.coupon_tile_border}`,
                    color: serverAppTheme?.primary_text
                  }}
                >
                  <div
                    className={cn(
                      "fs-26 px-2 text-break text-left",
                      item?.imageUrl ? "col-9" : "col-12",
                    )}
                  >
                    <div className="w-100 px-1 fs_16 fw-normal">{item?.name}</div>
                    {item?.imageUrl === null ? (
                      (!shouldShowOfferValue(item)) ? (
                        <></>
                      ) : (
                        <div
                          className="fs_14 w-100 py-1"
                        >
                          {getOfferValueText(item)}
                        </div>
                      )
                    ) : (
                      <></>
                    )}
                  </div>
                  {item?.description && (
                    <div className="fs-18 fw-normal py-1 text-left px-2" id="text">
                      {item?.description}
                    </div>
                  )}
                  {item?.imageUrl && (
                    <div className="col-3 p-0">
                      {item?.imageUrl !== null ? (
                        (!shouldShowOfferValue(item)) ? (
                          <></>
                        ) : (
                          <div className="text-center fs-16 w-100 py-1 od-text-primary text-primary">
                            {getOfferValueText(item)}
                          </div>
                        )
                      ) : (
                        <></>
                      )}
                      <img
                        className="img-build h-auto w-100"
                        src={item?.imageUrl}
                        alt=""
                      />
                    </div>
                  )}
                </div>
            );
          })
        ) : (
          <div
            className="h-100 d-flex justify-content-center align-items-center text-center fw-600"
            style={{
              fontSize: "2rem",
              color: serverAppTheme?.primary_text
            }}
          >
            {LABEL().LB_NO_OFFERS}
          </div>
        )}
      </div>
      <div className={cn(isLandScape && 'd-flex justify-content-center pb-3 pt-2 mb-2 overflowY')}>

      <button type="button" className={cn('btn-ripple od-primary-btn-bg-color od-primary-btn-font-color', isLandScape ? 'w-60 btn35': 'w-100 btn68')}
        style={{
          background: serverAppTheme?.secondaryBtn,
          color: serverAppTheme?.btn_font_color,
        }}
        >
        <div
          className={cn('fw-600', !isLandScape && 'fs_28')}
          role='button'
          tabIndex="0"
          onClick={() => handleRouteToChecKListing()}
          >
          {LABEL().LB_CLOSE}
        </div>
      </button>
          </div>
    </div>
  );
};


LoyaltyBalanceOffers.propTypes = {
  loyaltyOffers: PropTypes.array,
  handleRouteToChecKListing: PropTypes.func.isRequired, // ✅ FIX
  serverAppTheme: PropTypes.string,
  isLandScape: PropTypes.bool,
  seat: PropTypes.object,
};
const mapStateToProps = state => ({
  orderingPortraitOrientation: state.orders.orderingPortraitOrientation
});

export default connect(mapStateToProps)(LoyaltyBalanceOffers);
